export const socialShareConfig = {
    enabled: true,
    copyClipboardEnabled: false,
    shareWithEmail: {
        enabled: false
    }
};
